/**
 *
 *
 * @author Jaap
 * @date 23-09-2019
 */
import RecaptchaForm from "./RecaptchaForm";
import Analytics from "../utils/Analytics";

const RECAPTCHA_ACTION = "CONTACT";

export default class ContactPanel extends RecaptchaForm {
    constructor(panelElement) {
        super(panelElement, RECAPTCHA_ACTION);
        this.analytics = new Analytics();
    }

    submitFormData(recaptchaToken) {
        let formData = this.buildBaseFormData(recaptchaToken);
        if (window.frontend.getCurrentIssueId()) {
            formData.append("issue", window.frontend.dataHelper.getCurrentIssue().issue_title);
            formData.append("spread", window.frontend.dataHelper.getCurrentSpread().spread_title);
        }
        this.submitToApi(formData, "/en_EN/api/ContactForm.json");
    }

    postSuccess() {
        this.formElement.dataset["submitted"] = "success";

        this.analytics.sendEventUpdate(
            this.analytics.createUserEvent(["Interface-sidemenu", "Contact-tab", "Submit_contact_form"]),
        );
    }

    postError() {
        this.formElement.dataset["submitted"] = "failed";
    }
}
